import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { type PackSettingsView } from "../../types/state";
import { type RootState } from "../../../../Application/globaltypes/redux";
import { PricingTypes } from "enums/licensing/pricingTypes";

export interface PackSettingsState {
  settings: PackSettingsView;
  isLoading: boolean;
  isLoaded: boolean;
  error?: Error;
}

const initialState: PackSettingsState = {
  settings: {
    isFree: true,
    pricingTypeId: PricingTypes.Free,
    pricingSettings: {
      billingTermId: null,
      pricePerUser: undefined,
      isTrialAllowed: false,
      trialPeriodId: null,
    },
    licensingSettings: {
      unlimitedLicenses: true,
      noExpiration: true,
    },
  },
  isLoading: false,
  isLoaded: false,
  error: undefined,
};

const packSettingsSlice = createSlice({
  name: `${ReducerNamespaceTypes.Licensing}/${ReducerEntityPrefixTypes.Packs}/settings`,
  initialState,
  reducers: {
    reset: () => initialState,

    // Fetch actions
    fetchBegin(state: PackSettingsState) {
      state.isLoading = true;
    },
    fetchSuccess(state: PackSettingsState, action: PayloadAction<PackSettingsView>) {
      state.isLoaded = true;
      state.isLoading = false;
      state.settings = action.payload;
    },
    fetchFailure(state: PackSettingsState, action: PayloadAction<Error>) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // Update actions
    updateBegin(state: PackSettingsState) {
      state.isLoading = true;
    },
    updateSuccess(state: PackSettingsState, action: PayloadAction<PackSettingsView>) {
      state.isLoaded = true;
      state.isLoading = false;
    },
    updateFailure(state: PackSettingsState, action: PayloadAction<Error>) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { reset, fetchBegin, fetchSuccess, fetchFailure, updateBegin, updateSuccess, updateFailure } =
  packSettingsSlice.actions;

export const packSettingsSelector = (state: RootState) => state.packs.packSettingsReducer;

export default packSettingsSlice.reducer;
